import { IconButton, styled } from "@mui/material"

const sizes = {
    small: 32,
    medium: 40,
    large: 48,
}

const backgroundColors = (theme) => ({
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    tertiary: "transparent",
})

const colors = (theme) => ({
    primary: theme.palette.primary.contrast,
    secondary: theme.palette.secondary.contrast,
    tertiary: theme.palette["action/active"].main,
})

const hoverColors = (theme) => ({
    primary: theme.palette.primary.dark,
    secondary: theme.palette.secondary.dark,
    tertiary: theme.palette["objects/object-lightgrey"].main,
})

export const FilledIconButton = styled(IconButton, { shouldForwardProp: (prop) => prop !== "color" && prop !== "size" })(({ theme, color, size }) => ({
    backgroundColor: backgroundColors(theme)[color] || backgroundColors(theme).primary,
    color: colors(theme)[color] || colors(theme).primary,
    borderRadius: 9999,
    width: sizes[size],
    height: sizes[size],

    "&:hover": {
        backgroundColor: hoverColors(theme)[color] || hoverColors(theme).primary,
    },
}))